import React from "react";
import classNames from "classnames";
import { RatingLine, RatingSquare } from "ComponentsUI/RatingsViews";
import withStyles from "react-jss";
import { Tooltip, TooltipBody } from "ComponentsUI/Tooltip";
import { StubReviewItemB } from "ComponentsUI/Stub";

const styles = (theme) => {
	return {
		root: {
			width: "100%",
			display: "flex",
			alignItems: "flex-start",
			minHeight: "180px",
			position: "relative",
			marginBottom: "40px",
		},
		info: {
			width: "180px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			position: "relative",
			marginRight: "20px",
			flexShrink: 0,
		},
		infoEmotion: {
			display: "flex",
			backgroundColor: "transparent",
			width: "80px",
			height: "80px",
			border: `1px solid ${theme.palette.colors.superLightGrey}`,
			borderRadius: "50%",
			justifyContent: "center",
			alignItems: "center",
			marginBottom: "14px",
		},
		infoEmotionImage: {
			width: "36px",
			objectFit: "scale-down",
		},
		infoWrapper: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			width: "100%",
		},
		infoNameWrapper: {
			width: "100%",
		},
		infoName: {
			fontFamily: theme.fonts.bold,
			fontSize: "16px",
			lineHeight: "1.25",
			color: theme.palette.colors.darkSlateBlue2,
			marginBottom: "4px",
			textOverflow: "ellipsis",
			overflow: "hidden",
			whiteSpace: "nowrap",
			textAlign: "center",
		},
		infoTimeOfUse: {
			fontFamily: theme.fonts.medium,
			fontSize: "16px",
			lineHeight: "1.25",
			color: theme.palette.colors.darkSlateBlue2,
			marginBottom: "0px",
			marginTop: "15px",
			textOverflow: "ellipsis",
			overflow: "hidden",
			whiteSpace: "nowrap",
			textAlign: "left",
			display: "flex",
			"& span": {
				fontFamily: theme.fonts.bold,
			},
		},
		infoServiceOfUse: {
			fontFamily: theme.fonts.medium,
			fontSize: "16px",
			lineHeight: "1.25",
			color: theme.palette.colors.darkSlateBlue2,
			marginBottom: "0px",
			marginTop: "15px",
			textOverflow: "ellipsis",
			overflow: "hidden",
			whiteSpace: "nowrap",
			textAlign: "left",
			display: "flex",
			"& span": {
				fontFamily: theme.fonts.bold,
			},
		},
		infoNameStatus: {
			marginBottom: "3px",
			height: "18px",
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: "1.29",
			letterSpacing: "normal",
			textAlign: "center",
			color: theme.palette.colors.veryBlackGrey,
		},
		infoProvider: {
			marginBottom: "16px",
			textAlign: "center",
			textOverflow: "ellipsis",
			overflow: "hidden",
			width: "100%",
		},
		infoProviderName: {
			fontFamily: theme.fonts.bold,
			fontSize: "14px",
			lineHeight: "1.29",
			letterSpacing: "2px",
			color: theme.palette.colors.purplishBlue,
			marginRight: "2px",
			textTransform: "uppercase",
		},
		infoProviderCity: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: "1.14",
			textAlign: "center",
			color: theme.palette.colors.purplishBlue,
			textOverflow: "ellipsis",
			overflow: "hidden",
			whiteSpace: "nowrap",
			flexShrink: "0",
		},
		infoProviderArea: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: "1.14",
			textAlign: "center",
			color: theme.palette.colors.purplishBlue,
			textOverflow: "ellipsis",
			overflow: "hidden",
			whiteSpace: "nowrap",
			maxWidth: "180px",
		},
		infoDate: {
			textAlign: "center",
		},
		infoDateValue: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: "1.29",
			color: theme.palette.colors.veryBlackGrey,
			marginBottom: "2px",
		},
		// infoWatches: {
		//     display: "flex",
		//     alignItems: "center",
		//     justifyContent: "center"
		// },
		// infoWatchesIcon: {
		//     color: theme.palette.colors.veryBlackGrey,
		//     fontSize: "16px",
		//     marginRight: "6px"
		// },
		// infoWatchesCounter: {
		//     fontFamily: theme.fonts.medium,
		//     fontSize: "14px",
		//     lineHeight: "1.29",
		//     color: theme.palette.colors.veryBlackGrey
		// },
		infoAccept: {
			position: "absolute",
			top: "calc(100% + 35px)",
		},
		infoAcceptDarkText: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: "1.43",
			textAlign: "center",
			color: "#28262e",
		},
		infoAcceptGreyText: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: "1.43",
			textAlign: "center",
			color: theme.palette.colors.oneMoreGrey,
		},
		infoAcceptReviews: {
			marginTop: "15px",
		},
		infoAcceptStatus: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: "1.43",
			textAlign: "center",
			color: "#24ba8e",
		},
		infoAcceptActions: {
			marginTop: "10px",
			fontFamily: theme.fonts.bold,
			fontSize: "16px",
			lineHeight: "1",
			letterSpacing: "2.3px",
			color: "#5812fe",
			textTransform: "uppercase",
			cursor: "pointer",
		},
		actionsList: {
			position: "absolute",
			right: 0,
			width: "180px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
		actionsItem: {
			width: "80px",
			height: "80px",
			borderRadius: "50%",
			border: `solid 1px ${theme.palette.colors.disabled}`,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			cursor: "pointer",
			marginBottom: "20px",
			"&:last-child": {
				marginBottom: 0,
			},
		},
		actionsItemContent: {
			"& span": {
				color: theme.palette.colors.disabled,
				fontSize: "24px",
			},
		},
		actionsItemCounter: {
			fontFamily: theme.fonts.medium,
			fontSize: "12px",
			lineHeight: "1.5",
			textAlign: "center",
			color: theme.palette.colors.veryBlackGrey,
			marginTop: "-2px",
		},
		bodyWrapper: {
			position: "relative",
		},
		body: {
			width: "780px",
			padding: "25px 30px 0",
			borderRadius: "0 20px 20px 20px",
			position: "relative",
		},
		bodyMarkWrapper: {
			display: "flex",
			alignItems: "flex-start",
			marginBottom: "30px",
		},
		bodyMarkCategoryList: {
			display: "flex",
			flexWrap: "wrap",
			alignItems: "flex-start",
			marginTop: "-10px",
			marginRight: "-10px",
		},
		bodyHeader: {
			fontFamily: theme.fonts.bold,
			fontSize: "24px",
			color: theme.palette.colors.darkSlateBlue,
			lineHeight: 1,
		},
		bodyLikeWrapper: {
			marginTop: "23px",
		},
		bodyLikeHeader: {
			fontFamily: theme.fonts.bold,
			fontSize: "14px",
			letterSpacing: "2px",
			color: theme.palette.colors.white,
			marginBottom: "2px",
			textTransform: "uppercase",
		},
		bodyLikeText: {
			fontFamily: theme.fonts.light,
			fontSize: "15px",
			color: theme.palette.colors.white,
			marginTop: "32px",
		},
		bodyText: {
			fontFamily: theme.fonts.light,
			fontSize: "15px",
			color: theme.palette.colors.darkSlateBlue,
			marginTop: "32px",
		},
		bodyButton: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			letterSpacing: "2px",
			color: theme.palette.colors.darkSlateBlue,
			textTransform: "uppercase",
			marginTop: "15px",
			cursor: "pointer",
		},
		bodyFilesWrapper: {
			marginTop: "20px",
			fontSize: 0,
		},
		bodyFilesHeader: {
			fontFamily: theme.fonts.bold,
			fontSize: "14px",
			letterSpacing: "2px",
			color: theme.palette.colors.white,
			marginBottom: "20px",
			textTransform: "uppercase",
		},
		bodyFilesList: {
			display: "flex",
			flexWrap: "wrap",
			alignItems: "flex-start",
		},
		bodyFilesItem: {
			marginRight: "20px",
			cursor: "pointer",
			"& img": {
				height: "100px",
			},
			"&:last-child": {
				marginRight: 0,
			},
		},
		bodyTagsList: {
			marginTop: "20px",
			fontSize: 0,
			lineHeight: 0,
		},
		bodyTagsItem: {
			backgroundColor: "rgba(43, 29, 93,0.1)",
			borderRadius: "5px",
			padding: "5px 11px 6px",
			fontFamily: theme.fonts.light,
			fontSize: "15px",
			color: theme.palette.colors.white,
			marginRight: "10px",
			display: "inline-block",
			lineHeight: "1.33",
			cursor: "pointer",
			"&:last-child": {
				marginRight: 0,
			},
		},

		bodyShort: {
			width: "580px",
		},
		isStub: {
			"& $infoEmotion": {
				backgroundColor: theme.palette.colors.disabled,
			},
			"& $infoName": {
				height: "16px",
				borderRadius: "10px",
				backgroundColor: theme.palette.colors.disabled,
			},
			"& $infoProvider, $infoDate, $bodyMarkWrapper": {
				display: "none",
			},
			"& $body": {
				backgroundColor: theme.palette.colors.disabled,
				height: "300px",
				borderRadius: "10px",
			},
		},
		bottomLine: {
			display: "flex",
			alignItems: "center",
			marginTop: "32px",
			width: "100%",
		},
		statusList: {
			marginRight: "auto",
		},
		idWrapper: {
			marginLeft: "auto",
			fontSize: "14px",
			fontFamily: theme.fonts.medium,
			color: theme.palette.colors.cloudyBlue,
		},
		proofReviewWrapper: {
			display: "flex",
			alignItems: "center",
			marginRight: "48px",
			"& span": {
				fontSize: "16px",
				color: theme.palette.colors.disabled,
			},
		},
		proofedText: {
			fontSize: "15px",
			fontFamily: theme.fonts.bold,
			color: theme.palette.colors.darkSlateBlue,
			marginRight: "8px",
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			info: {
				width: "140px",
			},
			infoProviderArea: {
				maxWidth: "140px",
			},
			actionsList: {
				width: "140px",
			},
			body: {
				width: "100%",
			},
			bodyLikeWrapper: {
				marginTop: "24px",
			},
			bodyShort: {
				width: "540px",
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				flexWrap: "wrap",
				minHeight: 0,
			},
			info: {
				width: "50%",
				marginRight: 0,
				flexDirection: "row",
				marginBottom: "0",
			},
			infoEmotion: {
				width: "70px",
				height: "70px",
				marginBottom: 0,
				flexShrink: 0,
				marginRight: "20px",
			},
			infoWrapper: {
				flexDirection: "row",
				flexWrap: "wrap",
				justifyContent: "flex-start",
				width: "calc(100% - 90px)",
			},
			infoNameWrapper: {
				display: "flex",
				alignItems: "center",
				marginBottom: "3px",
			},
			infoName: {
				marginBottom: 0,
				marginRight: "13px",
			},
			infoTimeOfUse: {
				marginBottom: 0,
				marginRight: "13px",
			},
			infoServiceOfUse: {
				marginBottom: 0,
				marginRight: "13px",
			},
			infoNameStatus: {
				marginBottom: "-1px",
			},
			infoProvider: {
				marginBottom: "4px",
				display: "flex",
				alignItems: "center",
			},
			infoProviderArea: {
				display: "block",
				marginLeft: "5px",
			},
			infoDate: {
				display: "flex",
				alignItems: "center",
			},
			infoDateValue: {
				marginRight: "5px",
			},
			infoAccept: {
				display: "none",
			},
			actionsList: {
				position: "relative",
				width: "50%",
				flexDirection: "row",
				justifyContent: "flex-end",
			},
			actionsItem: {
				width: "70px",
				height: "70px",
				marginBottom: 0,
				marginRight: "20px",
				"&:last-child": {
					marginRight: 0,
					marginBottom: 0,
				},
			},
			bodyWrapper: {
				width: "100%",
			},
			body: {
				width: "100%",
			},
			bodyHeader: {
				fontSize: "18px",
			},
			bodyLikeWrapper: {
				marginTop: "20px",
			},
			bodyLikeHeader: {
				letterSpacing: "1.7px",
			},
			bodyText: {
				fontSize: "14px",
			},
			bodyButton: {
				fontSize: "12px",
				letterSpacing: "1.7px",
			},
			bodyFilesWrapper: {
				marginTop: "10px",
			},
			bodyFilesHeader: {
				fontSize: "12px",
				letterSpacing: "1.7px",
			},
			bodyFilesItem: {
				marginRight: "10px",
				"& img": {
					height: "80px",
				},
				"&:last-child": {
					marginRight: 0,
				},
			},
			bodyShort: {
				width: "100%",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				flexWrap: "wrap",
				minHeight: 0,
				marginBottom: "16px",
			},
			info: {
				width: "100%",
				flexDirection: "row",
				alignItems: "flex-start",
				marginRight: "0",
				marginBottom: "0",
			},
			infoEmotion: {
				backgroundColor: theme.palette.colors.transparent,
				width: "auto",
				height: "auto",
				border: "none",
				borderRadius: "0",
				justifyContent: "flex-start",
				alignItems: "flex-start",
				marginBottom: "0",
				marginRight: "18px",
			},
			infoWrapper: {
				alignItems: "flex-start",
			},
			infoName: {
				marginBottom: 0,
				marginRight: "5px",
			},
			infoTimeOfUse: {
				marginTop: "0px",
				flexDirection: "column",
				fontSize: "14px",
				marginBottom: "5px",
				marginRight: "5px",
			},
			infoServiceOfUse: {
				marginTop: "0px",
				flexDirection: "column",
				fontSize: "14px",
				marginBottom: "10px",
				marginRight: "5px",
			},
			infoNameWrapper: {
				display: "flex",
				alignItems: "center",
				marginBottom: "3px",
			},
			infoNameStatus: {
				marginBottom: 0,
			},
			infoProvider: {
				marginBottom: "2px",
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-start",
			},
			infoProviderName: {
				marginRight: "10px",
			},
			infoProviderCity: {
				marginRight: "5px",
			},
			infoProviderArea: {
				maxWidth: "100px",
			},
			infoDate: {
				display: "flex",
				justifyContent: "flex-start",
				alignItems: "center",
			},
			infoDateValue: {
				marginBottom: 0,
				marginRight: "15px",
			},
			infoAccept: {
				display: "none",
			},
			actionsList: {
				position: "relative",
				marginRight: "8.33%",
				marginLeft: "auto",
				width: "auto",
				flexDirection: "row",
				justifyContent: "flex-end",
			},
			actionsItem: {
				width: "auto",
				height: "auto",
				borderRadius: "0",
				border: "none",
				marginBottom: "0",
				marginRight: "26px",
				"&:last-child": {
					marginBottom: 0,
					marginRight: 0,
				},
			},
			actionsItemContent: {
				position: "relative",
				"& span": {
					color: theme.palette.colors.purplishBlue,
					fontSize: "20px",
				},
			},
			actionsItemCounter: {
				position: "absolute",
				top: "0",
				right: "-10px",
				marginTop: 0,
				lineHeight: "1",
			},
			bodyWrapper: {
				width: "100%",
			},
			bodyMarkWrapper: {
				display: "none",
			},
			body: {
				width: "100%",
				padding: "25px 8.33% 0",
				borderRadius: "0 20px 20px 20px",
				"&:before": {
					left: 0,
					top: "-25px",
					width: 0,
					height: 0,
					borderTop: 0,
					borderLeft: 0,
					borderBottom: `25px solid ${theme.palette.colors.transparent}`,
					borderRight: `25px solid ${theme.palette.colors.transparent}`,
				},
			},
			bodyMarkCategoryList: {
				display: "none",
			},
			bodyHeader: {
				display: "none",
			},
			bodyLikeWrapper: {
				display: "none",
			},
			bodyText: {
				fontSize: "14px",
				marginTop: 0,
			},
			bodyButton: {
				marginTop: "19px",
			},
			bodyFilesWrapper: {
				display: "none",
			},
			bodyTagsList: {
				display: "none",
			},
			bodyShort: {
				width: "100%",
			},
			bodyStatusList: {
				marginRight: "-16px",
				marginTop: "20px",
			},
			isStub: {
				"& $infoEmotion": {
					height: "36px",
					borderRadius: "50%",
				},
				"& $infoName": {
					width: "100px",
				},
			},
			bottomLine: {
				flexWrap: "wrap",
				marginTop: "16px",
			},
			proofReviewWrapper: {
				marginBottom: "5px",
				marginTop: "5px",
			},
			statusList: {
				marginBottom: "5px",
				marginTop: "5px",
			},
			idWrapper: {
				display: "none",
			},
		},
	};
};

class ReviewItemB extends React.PureComponent {
	static defaultProps = {
		markReviewAsViewed: () => {},
		text: "",
		item: {},
		tags: [],
		specifications: [],
		likes: null,
		countComments: null,
		type: "",
		status: null,
		name: "",
		provider: {},
		date: null,
		views_all: "",
		accepted: false,
		short: false,
		rating: 0,
		header: "",
		like: false,
		dislike: false,
		withFiles: false,
		singleReview: false,
		showFullHandler: () => {},
		onClickHandler: () => {},
		onClickCommentHandler: () => {},
		onClickReviewHandler: () => {},
		linkToProvider: <a />,
		proofed: false,
	};
	createServiceOfUse(service) {
		let classes = this.props.classes;
		let serviceString;
		switch (service) {
			case "internet":
				serviceString = (
					<div className={classes.infoServiceOfUse}>
						<span>Тип услуг:&nbsp;</span>
						<div>домашний интернет</div>
					</div>
				);
				break;
			case "internet_tv":
				serviceString = (
					<div className={classes.infoServiceOfUse}>
						<span>Тип услуг:&nbsp;</span>
						<div>интернет и тв</div>
					</div>
				);
				break;
			case "internet_mobile":
				serviceString = (
					<div className={classes.infoServiceOfUse}>
						<span>Тип услуг:&nbsp;</span>
						<div>интернет и мобильная связь</div>
					</div>
				);
				break;
			default:
				serviceString = null;
		}
		return serviceString;
	}

	createTimeOfUse(time) {
		let classes = this.props.classes;
		let timeString;
		switch (time) {
			case 1:
				timeString = (
					<div className={classes.infoTimeOfUse}>
						<span>Срок использования:&nbsp;</span>
						<div>Меньше 3 месяцев</div>
					</div>
				);
				break;
			case 2:
				timeString = (
					<div className={classes.infoTimeOfUse}>
						<span>Срок использования:&nbsp;</span>
						<div>3 месяца - 1 год</div>
					</div>
				);

				break;
			case 3:
				timeString = (
					<div className={classes.infoTimeOfUse}>
						<span>Срок использования:&nbsp;</span>
						<div>1 год и более</div>
					</div>
				);

				break;
			default:
				timeString = null;
		}
		return timeString;
	}

	createTags() {
		let classes = this.props.classes;
		return (
			this.props.tags &&
			this.props.tags.map((item, index) => {
				return (
					<div key={index} className={classes.bodyTagsItem}>
						{item}
					</div>
				);
			})
		);
	}

	generateSpecificationsList() {
		return this.props.specifications.map((o, k) => {
			return <RatingLine item={o} key={k} whiteTheme={true} color={"white"} />;
		});
	}

	render() {
		let classes = this.props.classes;

		let text = this.props.textConst;
		let name = !!this.props.name ? this.props.name : text.UNKNOWN_GUEST;

		let linkToProvider = React.cloneElement(
			this.props.linkToProvider,
			{
				className: classes.infoProviderName,
				datatest: "reviews_provider_button",
			},
			[this.props.provider.name]
		);

		const providerPhone = this.props.provider?.contacts?.phones[0];

		if (this.props.stub) {
			return <StubReviewItemB {...this.props} />;
		}

		return (
			<div
				className={classNames(classes.root, {
					[classes.isStub]: this.props.stub,
				})}
				itemScope
				itemProp="review"
				itemType="https://schema.org/Review"
			>
				<div className={classes.info}>
					<div className={classes.infoEmotion}>
						{!this.props.stub && (
							<picture>
								<source
									type="image/webp"
									srcSet={
										!!this.props.webpTransformer
											? this.props.webpTransformer(this.props.logo)
											: this.props.logo
									}
								/>
								<source srcSet={this.props.logo} />
								<img
									alt={"reviewType"}
									className={classes.infoEmotionImage}
									src={this.props.logo}
								/>
							</picture>
						)}
						{this.props.stub && <div className={classes.infoEmotionImage} />}
					</div>
					<div className={classes.infoWrapper}>
						<div className={classes.infoNameWrapper}>
							<div
								className={classes.infoName}
								itemProp="author"
								itemScope
								itemType="https://schema.org/Person"
							>
								<span itemProp="name">{!this.props.stub && name}</span>
							</div>
						</div>

						<div
							className={classes.infoProvider}
							itemProp="itemReviewed"
							itemScope
							itemType="https://schema.org/Organization"
						>
							<span itemProp="name">{linkToProvider}</span>
							<meta itemProp="telephone" content={providerPhone} />
						</div>
						<div className={classes.infoDate}>
							<div className={classes.infoDateValue} itemProp="datePublished">
								{this.props.date}
							</div>
						</div>
					</div>
				</div>
				<div className={classes.bodyWrapper}>
					<div
						className={classNames(classes.body, {
							[classes.bodyShort]: this.props.short,
						})}
					>
						<div
							className={classes.bodyMarkWrapper}
							itemProp="reviewRating"
							itemScope
							itemType="http://schema.org/Rating"
						>
							<meta itemProp="worstRating" content="0" />
							<meta
								itemProp="ratingValue"
								content={
									Number.isInteger(this.props.rating)
										? this.props.rating
										: this.props.rating.toFixed(1)
								}
							/>
							<meta itemProp="bestRating" content="10" />
							<RatingSquare
								text={text.FULL_MARK}
								whiteTheme={true}
								color={"white"}
								mark={
									Number.isInteger(this.props.rating)
										? this.props.rating
										: this.props.rating.toFixed(1)
								}
							/>
							<div className={classes.bodyMarkCategoryList}>
								{this.generateSpecificationsList()}
							</div>
						</div>
						{!this.props.singleReview && this.props.header != "empty" && (
							<div className={classes.bodyHeader} itemProp="name">
								{this.props.header}
							</div>
						)}
						{this.props.singleReview && this.props.header != "empty" && (
							<h1 className={classes.bodyHeader} itemProp="name">
								{this.props.header}
							</h1>
						)}
						{this.props.time_of_use ? this.createTimeOfUse(this.props.time_of_use) : null}

						{this.props.services_of_use
							? this.createServiceOfUse(this.props.services_of_use)
							: null}
						<div className={classes.bodyText} itemProp="reviewBody description">
							{this.props.showButton
								? this.props.text.substring(0, 500).concat("...")
								: this.props.text}
						</div>
						{this.props.showButton && (
							<div
								className={classes.bodyButton}
								datatest="reviews_deployreviews_button"
								onClick={(e) => this.props.showFullHandler(e)}
							>
								{text.SHOW_ALL_REVIEW}
							</div>
						)}
						<div className={classes.bottomLine}>
							{this.props.proofed && (
								<div className={classes.proofReviewWrapper} onClick={(e) => e.stopPropagation()}>
									<div className={classes.proofedText}>{text.PROOFED_REVIEW}</div>
									<Tooltip body={<TooltipBody>{text.PROOFED_REVIEW_TEXT}</TooltipBody>}>
										<span className="icon24 icon-question" />
									</Tooltip>
								</div>
							)}
							{!!this.props.status && <div className={classes.statusList}>{this.props.status}</div>}
							{this.props.id && <div className={classes.idWrapper}>{this.props.id}</div>}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default withStyles(styles)(ReviewItemB);

export { ReviewItemB as __ReviewItemB };
